import "bootstrap/dist/css/bootstrap.min.css";
import FindCarForm from "../../../components/modules/Home/FindCarForm";
import LocateUs from "../../../components/modules/Home/LocateUs";
import Features from "../../../components/common/Features";
import Benefits from "../../../components/modules/Home/Benefits";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight
} from "@fortawesome/free-solid-svg-icons";
import Carousel from "react-bootstrap/Carousel";
import ContactUs from "../../../components/common/ContactUs";
import CarsByLifestyle from "../../../components/modules/Home/CarsByLifestyle";
import Location from "../../../components/modules/Home/HomeLocation";
import Faq from "../../../components/common/Faq";
import Testimonials from "../../../components/common/Testimonial";
import { Link } from "react-router-dom";
import SellCarBanner from "../../../components/common/SellCarBanner";
import AssuredCars from "../../../components/common/AssuredCars";
import CarsByBodyType from "../../../components/modules/Home/CarsByBodyType";
import PopularBrands from "../../../components/common/PopularBrands";
import React, { useState, useEffect } from 'react';
import HTTP from "../../../config/axios";
import { encryptLocalStorage } from "../../../config/utils/storage";
import WhoAreWe from "../../../components/common/WhoAreWeBanner";
import DealOfTheDay from "../../../components/modules/Home/DealOfTheDay";
import { useSearchParams, useNavigate } from "react-router-dom";
import PopularCars from "../../../components/common/PopularCars";

const Home = () => {
  const [findYourcarCms, setFindYourcarCms] = useState({});
  const [featuresCms, setFeaturesCms] = useState("");
  const [whoAreWeCms, setWhoAreWeCms] = useState<any>({});
  const [whoAreWeMobileCms, setWhoAreWeMobileCms] = useState<any>({});
  const location = encryptLocalStorage.getItem("selectedLocation") || "";
  const [faqCms, setFaqCms] = useState("");
  const [carsForBudgetLifestyle, setCarsForBudgetLifestyle] = useState<any>({});
  const [benefitsCms, setBenefitsCms] = useState("");
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();


  const handleClick = () => {
    navigate("/buy-used-car?reset=true", { replace: true });
  };

  useEffect(() => {
    const homeCms = async () => {
      const cmsData = await HTTP.post(`/api/cms/fetch-all`,
        {
          nameList: ["find-your-car-now", "features", "who-are-we", "who-are-we-mobile", "faq-component", "cars-for-every-budget-and-lifestyle", "home-benefits"]
        })
      const { data: { status, data, msg, error } } = cmsData

      data.forEach((cmsContent: any) => {
        if (cmsContent.name === "find-your-car-now") {
          setFindYourcarCms(cmsContent);
        } else if (cmsContent.name === "features") {
          setFeaturesCms(cmsContent);
        } else if (cmsContent.name === "who-are-we") {
          setWhoAreWeCms(cmsContent);
        } else if (cmsContent.name === "who-are-we-mobile") {
          setWhoAreWeMobileCms(cmsContent);
        } else if (cmsContent.name === "faq-component") {
          setFaqCms(cmsContent);
        } else if (cmsContent.name === "cars-for-every-budget-and-lifestyle") {
          setCarsForBudgetLifestyle(cmsContent);
        } else if (cmsContent.name === "home-benefits") {
          setBenefitsCms(cmsContent);
        }
      })
    }

    homeCms()
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isPortrait = height > width;

      // Mobile: width <= 767 only
      const mobile = width <= 767;
      // Tablet: width 768-1199 (both portrait and landscape)
      const tablet = width >= 768 && width <= 1199;
      setIsMobile(mobile);
      setIsTablet(tablet);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);


  return (
    <div className="App">
      <Carousel className="home-carousel">
        <Carousel.Item>
          {isMobile ? (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page-Banner-Venue-mobile-450×800.jpg`}
              alt="First slide"
            />
          ) : isTablet ? (
            window.innerHeight > window.innerWidth ? (
              <img
                className="d-block"
                  src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page-Banner-Venue-tab-potrait-820×1286.jpg`}
                alt="First slide"
              />
            ) : (
              <img
                className="d-block"
                    src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page-Banner-Venue-landscape-844×425.jpg`}
                alt="First slide"
              />
            )
          ) : (
            <img
              className="d-block"
                  src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page-Banner-Venue-desktop-1200×600.jpg`}
              alt="First slide"
            />
          )}
          <Carousel.Caption>
            <h4 className="text-primary is-sub-heading mt-0" dangerouslySetInnerHTML={{ __html: carsForBudgetLifestyle && carsForBudgetLifestyle.title }}></h4>
            <div dangerouslySetInnerHTML={{ __html: carsForBudgetLifestyle && carsForBudgetLifestyle.content }}></div>
            <button onClick={handleClick} className="btn btn-primary mt-0">
              Browse now <FontAwesomeIcon icon={faAngleRight} />
            </button>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          {isMobile ? (
            <img
              className="d-block"
              src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page Banner-yoga- 450×800.jpg`}
              alt="Second slide"
            />
          ) : isTablet ? (
            window.innerHeight > window.innerWidth ? (
              <img
                className="d-block"
                  src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page-Banner-yoga- 1180×771 2.jpg`}
                alt="Second slide"
              />
            ) : (
              <img
                className="d-block"
                    src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page Banner-yoga-844×425.jpg`}
                alt="Second slide"
              />
            )
          ) : (
            <img
              className="d-block"
                  src={`${process.env.REACT_APP_CLOUDFRONT_URL}/home_page_banner/Home-Page Banner-yoga-1200x600.jpg`}
              alt="Second slide"
            />
          )}
          <Carousel.Caption>
            <div className="carousel-right col-md-12">
              <h4 className="text-primary is-sub-heading mt-1" dangerouslySetInnerHTML={{ __html: carsForBudgetLifestyle && carsForBudgetLifestyle.title }}></h4>
              <div dangerouslySetInnerHTML={{ __html: carsForBudgetLifestyle && carsForBudgetLifestyle.content }}></div>
              <button onClick={handleClick} className="btn btn-primary mt-0">
                Browse now <FontAwesomeIcon icon={faAngleRight} />
              </button>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      <FindCarForm cmsContent={findYourcarCms} />
      {benefitsCms && <Benefits cmsContent={benefitsCms} />}
      <SellCarBanner />
      <Location />
      {/* {featuresCms && <Features cmsContent={featuresCms} />} */}
      <Features />
      <CarsByLifestyle />
      <PopularBrands />
      <CarsByBodyType />
      <DealOfTheDay />
      {/* <PopularCars/> */}
      <hr className="mb-5" />
      <LocateUs />
      <hr className="mb-5" />
      <AssuredCars />
      {faqCms && <Faq cmsContent={faqCms} />}
      <Testimonials />
      {whoAreWeCms && <WhoAreWe whoAreWeCms={isMobile ? whoAreWeMobileCms : whoAreWeCms} />}
      <ContactUs />

    </div >
  );
};

export default Home;
